import { transport } from 'config/transport';

export function callApiGetInvoicePayments(congDoanId, classId, month, year) {
    return transport.get(`/mamnon/${congDoanId}/thuchi/${classId}/thumamnon/payment`, { params: { month, year } });
}
